import type { Interceptor } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { env } from "~/env";

/**
 * Creates a ConnectRPC browser transport that injects the given access token
 * as a Bearer Authorization header on every request.
 *
 * A new transport is created per-request (or per-query invocation) so the
 * token is always fresh; oidc-client-ts handles silent renewal transparently.
 */
export function createTransport(accessToken: string | null) {
  const authInterceptor: Interceptor = (next) => async (req) => {
    if (accessToken) {
      req.header.set("Authorization", `Bearer ${accessToken}`);
    }
    return next(req);
  };

  return createConnectTransport({
    baseUrl: env.VITE_API_BASE_URL,
    interceptors: [authInterceptor],
  });
}
